import { render, staticRenderFns } from "./InHouseRepairsIndex.vue?vue&type=template&id=7486d71b&scoped=true"
import script from "./InHouseRepairsIndex.vue?vue&type=script&lang=js"
export * from "./InHouseRepairsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7486d71b",
  null
  
)

export default component.exports